<form [formGroup]="form()">
  <div class="grid" *ngIf="tenantType() === 'Contractor'">
    <div class="col-4">
      <label class="label" for="contractorNumber">Lieferantennummer</label>
      <input fullWidth id="contractorNumber"
             type="text" nbInput formControlName="contractorNumber" [readonly]="!isEditing">
      <div class="error" *ngIf="hasError('contractorNumber')">Maximal 10 Zeichen!</div>
    </div>
    <div class="col-4">
      <label class="label" for="facilityElements">Technische Einrichtung</label>
      <wr-facility-element-multi-select id="facilityElements" formControlName="facilityElements">
      </wr-facility-element-multi-select>
    </div>
  </div>
</form>
